import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import classNames from 'classnames'
import { dataHas } from '../../common/ambient'
import FormattedDataPoint from './FormattedDataPoint'

// Cascade test station: http://localhost:3100/dashboard/3f8e3f36742012775b8cf7f4165ec0c0 (20:00:00:00:02:35)

export default class BattVoltsWidget extends PureComponent {
  static propTypes = {
    currentDevice: PropTypes.object.isRequired,
  };

  render() {
    const { currentDevice } = this.props
    const { lastData } = currentDevice
    const data = lastData
    let widget = <div className="device-batt-volts-widget hidden" />
    let batt1 = ""
    let batt2 = ""
    const currentDataHas = dataHas(data)
    if (currentDataHas('batt1volts')) {
      batt1 =
        <div>
          <div className="label">
            Station
          </div>
          <FormattedDataPoint type={'batt1volts'} row={lastData} />
        </div>
    }
    if (currentDataHas('batt2volts')) {
      batt2 =
        <div>
          <div className="label">
            TeleMET
          </div>
          <FormattedDataPoint type={'batt2volts'} row={lastData} />
        </div>
    }
    widget = 
        <div className="device-batt-volts-widget">
          {batt1}
          {batt2}
        </div>

    return widget
  }
}

BattVoltsWidget.propTypes = {};
BattVoltsWidget.defaultProps = {};

BattVoltsWidget.displayName = 'BattVoltsWidget'
